// ドロワーメニュー SP＋タブレット（960px未満）
const mqSp = window.matchMedia('(max-width: 959px)'); // ドロワー表示の範囲（SP＋タブレット）
const header = document.querySelector('header');

let teardown = null;

// 開いている子メニューを全部閉じる（インラインの max-height も消す）
const closeAllChildMenus = () => {
	document.querySelectorAll('.navi__has-child.is-open').forEach((parent) => {
		const child = parent.querySelector('.navi__child');
		if (child) child.style.maxHeight = '';
		parent.classList.remove('is-open');
	});
};

const initDrawer = () => {
	const navTrigger = document.querySelector('.nav-trigger');
	const body = document.body;
	if (!navTrigger) return null;

	let scrollPosition = 0;

	const openNav = () => {
		scrollPosition = window.scrollY || document.documentElement.scrollTop;
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		if (header) header.classList.remove('is-hidden'); // 隠れたまま開くと閉じるボタンが見えない
		body.classList.add('nav-open');
		body.style.cssText = `position:fixed;width:100%;height:100%;top:-${scrollPosition}px;padding-right:${scrollbarWidth}px`;
	};

	const closeNav = () => {
		body.classList.remove('nav-open');
		body.removeAttribute('style');
		closeAllChildMenus();
		window.scrollTo(0, scrollPosition);
	};

	const handleTriggerClick = (e) => {
		e.preventDefault();
		body.classList.contains('nav-open') ? closeNav() : openNav();
	};

	const handleOrientationChange = () => {
		body.classList.add('is-resizing');
		body.removeAttribute('style');
		body.classList.remove('nav-open');
		closeAllChildMenus();
		setTimeout(() => body.classList.remove('is-resizing'), 300);
	};

	// 子メニューを持つ親リンクは開閉に使うので、ドロワーを閉じる対象から外す
	const isParentLink = (el) => el.parentElement && el.parentElement.classList.contains('navi__has-child');
	const closableLinks = [...document.querySelectorAll('header nav a, .overlay')].filter((el) => !isParentLink(el));

	navTrigger.addEventListener('click', handleTriggerClick);
	closableLinks.forEach((el) => el.addEventListener('click', closeNav));
	window.addEventListener('orientationchange', handleOrientationChange);

	return () => {
		navTrigger.removeEventListener('click', handleTriggerClick);
		closableLinks.forEach((el) => el.removeEventListener('click', closeNav));
		window.removeEventListener('orientationchange', handleOrientationChange);
		closeNav();
	};
};

let resizeTimer = null;

const syncDrawer = () => {
	// 幅がドロワー境界をまたぐ瞬間に transition が走らないよう一時的に止める
	document.body.classList.add('is-resizing');
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(() => document.body.classList.remove('is-resizing'), 300);

	if (teardown) {
		teardown();
		teardown = null;
	}
	// 幅が変わったら開閉状態を持ち越さない（PCに戻った時、残った max-height で子メニューが切れる）
	closeAllChildMenus();

	if (mqSp.matches) {
		teardown = initDrawer();
	} else {
		document.body.classList.remove('nav-open');
		document.body.removeAttribute('style');
	}
};

mqSp.addEventListener('change', syncDrawer);
syncDrawer();

// グローバルナビの子メニュー開閉（SPのみ。PCはCSSのホバーで開く）
// max-height を実寸に差し替えて開く（display切り替えではtransitionが効かない）
document.querySelectorAll('.navi__has-child').forEach((parent) => {
	const child = parent.querySelector('.navi__child');
	const toggle = parent.querySelector('.navi__toggle');
	const link = parent.querySelector(':scope > a');
	if (!child) return;

	const toggleChild = (e) => {
		if (!mqSp.matches) return;
		e.preventDefault();

		if (parent.classList.contains('is-open')) {
			child.style.maxHeight = '';
			parent.classList.remove('is-open');
		} else {
			parent.classList.add('is-open');
			child.style.maxHeight = `${child.scrollHeight}px`;
		}
	};

	if (toggle) toggle.addEventListener('click', toggleChild);
	// 親リンクのタップでも開閉する（一覧へは子の先頭「一覧を見る」から）
	if (link) link.addEventListener('click', toggleChild);
});
